import styled, { css } from 'styled-components'

type WrapperProps = {
  $highlight?: boolean
}

export const Wrapper = styled.div<WrapperProps>`
  ${({ $highlight }) =>
    $highlight
      ? css`
          border: 2px solid var(--blue-light);
        `
      : css`
          border: 1px solid var(--gray-200);
        `}
`

Wrapper.displayName = 'Wrapper'

export const LoadingWrapper = styled.div`
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  &:before {
    content: '';
    background: var(--gray-100);
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    opacity: 0.8;
  }

  > div {
    z-index: 1;
  }
`

LoadingWrapper.displayName = 'LoadingWrapper'
